import React from "react";
import { T, FAMILY, FONT } from "../theme/tokens.js";
import { APP_NAME } from "../config.js";
import { Wordmark, Notice, Label } from "../components/ui/index.jsx";

/* Shown when the two Supabase environment values are missing. Without this
   the app would fail with a blank screen and a console error, which is not
   a useful thing to hand a project manager. */
export default function Setup() {
  return (
    <div style={{
      minHeight: "100vh", background: T.navy, display: "flex",
      alignItems: "center", justifyContent: "center", fontFamily: FAMILY, padding: 16,
    }}>
      <style>{FONT}</style>
      <div style={{
        background: T.panel, border: `1px solid ${T.line}`, borderTop: `4px solid ${T.gold}`,
        borderRadius: 6, padding: 32, width: "100%", maxWidth: 520,
      }}>
        <Wordmark onLight />
        <div style={{ marginTop: 12 }}><Label>{APP_NAME}</Label></div>
        <h2 style={{ fontSize: 18, color: T.navy, margin: "14px 0 8px" }}>Not connected yet</h2>
        <p style={{ fontSize: 14, color: T.ink, lineHeight: 1.6, marginTop: 0 }}>
          The app is built and deployed, but it has not been told which database to
          talk to. Two values are needed, both from the Supabase dashboard under
          Project Settings, API.
        </p>
        <ul style={{ fontSize: 14, color: T.ink, lineHeight: 1.7 }}>
          <li><code>VITE_SUPABASE_URL</code>, the Project URL</li>
          <li><code>VITE_SUPABASE_ANON_KEY</code>, the anon or publishable key</li>
        </ul>
        <p style={{ fontSize: 14, color: T.ink, lineHeight: 1.6 }}>
          Running locally, put them in a file called <code>.env</code>. Deployed,
          add them in Netlify under Site configuration, Environment variables, then
          redeploy.
        </p>
        <Notice kind="warn">
          Never use the service_role or secret key here. It ignores every access
          rule in the database. Only the anon key belongs in the browser.
        </Notice>
      </div>
    </div>
  );
}
